import { useQuery } from '@tanstack/react-query';

import { CerberusApi } from '@hcs/cerberus';
import {
  MsaRpiTimeSeriesDocument,
  MsaRpiTimeSeriesQuery,
  MsaRpiTimeSeriesQueryVariables,
} from '@hcs/types';

import { msaRpiTSQueryToCerberusRpiTS } from '../utils/cerberus-stats.utils';

const QUERY_KEY_MSA_RPI_TIME_SERIES = 'msa-rpi-time-series';

export const useMsaRpiTimeSeries = ({
  msaId,
  fromDate,
  toDate,
  enabled = true,
}: MsaRpiTimeSeriesQueryVariables & {
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: [QUERY_KEY_MSA_RPI_TIME_SERIES, msaId, fromDate, toDate],

    queryFn: async () => {
      const response = await CerberusApi.fetchQuery<
        MsaRpiTimeSeriesQuery,
        MsaRpiTimeSeriesQueryVariables
      >(MsaRpiTimeSeriesDocument, {
        msaId,
        fromDate,
        toDate,
      });
      return msaRpiTSQueryToCerberusRpiTS(response);
    },

    enabled,
  });
};
